import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { LegacyEmailReceiptEntity } from './legacy-email-receipt.entity';

@Entity('_email')
export class LegacyEmailEntity extends BaseEntity {
	@Column('varchar', { name: '_email', nullable: true, length: 255 })
	public email!: string | null;

	@Column({ type: 'boolean', name: '_unsubscribed', nullable: true, width: 1 })
	public unsubscribed!: boolean | null;

	@Column('varchar', { name: '_type', nullable: true, length: 255 })
	public type!: string | null;

	@Column({
		type: 'boolean',
		name: '_excluded',
		nullable: true,
		width: 1,
		default: () => "'0'",
	})
	public excluded!: boolean | null;

	@OneToMany(
		() => LegacyEmailReceiptEntity,
		(emailReceipt) => emailReceipt.fkEmail,
		{},
	)
	public emailReceipts!: Array<LegacyEmailReceiptEntity>;
}
